import React from "react";
import "./EventGallery.css";

const EventGallery2016 = () => {
  const images = [
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/1.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/2.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/3.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/4.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/5.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/6.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/7.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/8.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/9.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/10.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/11.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/12.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/13.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/14.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/15.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/16.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/17.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/18.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/19.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/20.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/21.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/22.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/23.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/24.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/25.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/26.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/27.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/28.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/29.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/30.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/31.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/32.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/33.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/34.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/35.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/36.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/37.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/38.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/39.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/40.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2016/41.jpg",
    
  ];

  return (
    <div className="event-gallery-container">
      <h2 className="event-gallery-title">Event 2016</h2>
      <div className="event-gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="event-gallery-card">
            <img src={img} alt={`Event ${index + 1}`} />
          </div> 
        ))}
      </div>
    </div>
  );
};

export default EventGallery2016;